import { type FC, type PropsWithChildren } from 'react'

import { TakeoverContentWrapperBase } from '@/components-page/advertisement/TakeoverContentWrapperBase'
import { GPT_COMPONENT_ID } from '@/features/advertisement/constants/adSlots'
import { useTakeoverDetection } from '@/hooks/useTakeoverDetection'

export const TakeoverContentWrapper: FC<PropsWithChildren> = ({ children }) => {
  const hasTakeover = useTakeoverDetection(GPT_COMPONENT_ID.TAKEOVER)

  return (
    <TakeoverContentWrapperBase hasTakeover={hasTakeover}>{children}</TakeoverContentWrapperBase>
  )
}
